export const STATS_SET_PERIOD = 'STATS_SET_PERIOD';
export const STATS_INC_PERIOD = 'STATS_INC_PERIOD';
export const STATS_DEC_PERIOD = 'STATS_DEC_PERIOD';
export const STATS_GET_HISTORY = 'STATS_GET_HISTORY';
export const STATS_GET_COUNT = 'STATS_GET_COUNT';
export const STATS_GET_WINE_RANKING = 'STATS_GET_WINE_RANKING';
export const STATS_GET_WAF = 'STATS_GET_WAF';
